import * as ActionTypes from "../ActionTypes";
// import { getUserRoleChangeData } from "../Actions/UserManagementAction";

const initialState = {
  UserManagementData: [],
  UserRoleChangeData: [],
  hydrated: false,
};
export default function UserManagementReducer(state, action) {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  switch (action.type) {
    case ActionTypes.GET_USER_MANAGEMENT_DATA: {
      return {
        ...state,
        UserManagementData: action.payload.data,
        UserManagementDataFiltered: action.payload.data,
      };
    }
    case ActionTypes.SET_USER_MANAGEMENT_STATE_PARAMS: {
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    }
    default:
      return state;
  }
}
